import type { ClientInvoicingInstructionsRequest } from '@contracts/client/ClientInvoicingInstructionsRequest';
import { ClientsClient } from '@src/clients/services/ClientsClient';
import { useMutation } from '@tanstack/react-query';

interface Props {
  clientId: string;
  onSuccess: () => void;
  onError: () => void;
}

export const useUpdateInvoicingInstructions = ({
  clientId,
  onSuccess,
  onError,
}: Props) => {
  const { mutate, isPending, isError } = useMutation({
    mutationFn: (data: ClientInvoicingInstructionsRequest) => {
      return ClientsClient.updateInvoicingInstructions(clientId, data);
    },
    onSuccess,
    onError,
  });

  return {
    updateInvoicingInstructions: mutate,
    isLoading: isPending,
    isError,
  };
};
